import { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { registerToastListener } from '@/lib/toast';
import type { ToastMessage } from '@/lib/toast';

export default function GlobalToast() {
  const [queue, setQueue] = useState<ToastMessage[]>([]);
  const current = queue[0];

  useEffect(() => registerToastListener((toast) => setQueue((q) => [...q, toast])), []);

  const handleClose = () => setQueue((q) => q.slice(1));

  return (
    <Snackbar
      key={current?.id}
      open={Boolean(current)}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      {current ? (
        <Alert onClose={handleClose} severity={current.severity} variant="filled" sx={{ width: '100%' }}>
          {current.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
}
